import moment from "moment";
import React from "react";
import { ModalContentWrapper } from "./accept_advertisement_modal_helpers";
import ProductInstructionsInfo from "../product_instructions_info";
import { ProductExchangeTypeMailing } from "../../../../constants/campaigns";

const NextStepsContent = props => {
  const { campaign, campaignItem } = props;
  const respondByMoment =
    (campaignItem.uploadAudioBy ?? 0) > 0 ? moment.unix(campaignItem.uploadAudioBy) : moment();
  const respondDaysLeft = respondByMoment.toNow(true);
  return (
    <>
      <div>Thanks for accepting this offer!</div>
      <br />
      <div>
        You’ll have <strong>{respondDaysLeft}</strong> to receive your product sample and upload the
        audio for your Host-Read Ad. When you’re ready to upload your audio, return to your
        Advertising Dashboard and select <strong>“Upload Audio.”</strong>
      </div>
      <br />
      <div className={"m-bxs"}>
        Audio must be uploaded by {respondByMoment.format("LL")} which is 2 days before the campaign
        start date.
      </div>
      {campaign.productExchangeInstructions && <ProductInstructionsInfo {...props} />}
      {campaign.productExchangeType === ProductExchangeTypeMailing && (
        <div>
          <div className="bold">INSTRUCTIONS FOR RECEIVING PRODUCT SAMPLES</div>
          Brand will ship the product sample to the mailing address provided
        </div>
      )}
    </>
  );
};
export const nextStepsConfig = props => ({
  title: "Next Steps",
  closeOnly: true,
  closeText: "Okay",
  Content: (
    <ModalContentWrapper>
      <NextStepsContent {...props} />
    </ModalContentWrapper>
  ),
});
